import { render, staticRenderFns } from "./OrdersPivotFilters.vue?vue&type=template&id=09557a44&scoped=true&"
import script from "./OrdersPivotFilters.vue?vue&type=script&lang=ts&"
export * from "./OrdersPivotFilters.vue?vue&type=script&lang=ts&"
import style0 from "./OrdersPivotFilters.vue?vue&type=style&index=0&id=09557a44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09557a44",
  null
  
)

export default component.exports